import 'Variables';
import {sessionStorage as storage} from 'bobjoll/ts/library/storage';

declare module "bobjoll/ts/library/storage" {
    interface ClientStorage {
        get(namespace: 'language', key: string): string[];
        set(namespace: 'language', key: string, value: string[]): void;
    }
}

const STORAGE_LANGUAGE_NS = 'language';
const sprintf = require("sprintf-js").sprintf;

export default function(str: string, ...args: string[]) {
    const argumentsLength = arguments.length - 1;
    const string = 'undefined' !== typeof LANGUAGE_STRINGS && LANGUAGE_STRINGS[str] ? LANGUAGE_STRINGS[str] : str;

    if (argumentsLength < 1) {
        return string;
    } else {
        try {
            const settings = args.reduce((acc: string[], item: any, index: number) => {
                acc.push(item);
    
                return acc;            
            }, [string]);
    
            return sprintf.apply(null, settings);
        } catch(err) {
            console.error(err, language[str] || str);

            return str;
        }
    }
}